/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(".header__cart-toggle").click(function(){
  if(!$("body").hasClass("template-cart")){
    // $("body").addClass("hidescroll");
    document.querySelector('html').style.overflow = 'hidden';
  }
});

$(".faq2-acod-boxhead").click(function() {
  $(this).toggleClass("faq2-expand");
  $(this).next(".faq2-content").slideToggle();
});

var boldAddClassforRadio = setInterval(function() {

  
  if($(".bold_option_value").length > 0){
    $(".bold_option_value_element input").click(function(){

      $(".bold_option_value").each(function(){
        $(this).removeClass("bundle_bg");
        var radio = $(this).find("input[type='radio']");
        if(radio.prop("checked")){
          $(this).addClass("bundle_bg");
        }
      });	
      
    });
    clearInterval(boldAddClassforRadio);
  }
  
}, 1000);

var boldAddClassforCheckbox = setInterval(function() {

  
  if($(".bold_option_value").length > 0){
    $(".bold_option_element input").click(function(){

      $(".bold_option_checkbox").each(function(){
        $(this).removeClass("bundle_bg");
        var radio = $(this).find("input[type='checkbox']");
        if(radio.prop("checked")){
          $(this).addClass("bundle_bg");
        }
      });	
      
    });
    clearInterval(boldAddClassforCheckbox);
  }
  
}, 1000);



$("document").ready(function(){
  $(window).resize(function(){
    if(($(window).width() < 1000) && $(".collection__layout-button[data-layout-mode='list']").hasClass("is-selected")) {
      $(".collection__layout-button[data-layout-mode='grid']").click();
    }

  });

  // auto redirect to the brand landing page
  var mainSearchInput = document.getElementById("main-search-input");
  mainSearchInput.addEventListener("keypress", function(event) {
	
    // If the user presses the "Enter" key on the keyboard
    if (event.key === "Enter") {
      event.preventDefault();
      var brandMatched = false;
      var intervalinit = setInterval(function () {
        if(!($(".icon--search-loader").is(":visible"))){
          if($("p.brand-available").length > 0){
              var enteredValue = $("#main-search-input").val().toLowerCase();
              $("p.brand-available+ul li").each(function(){
                var optionValue = $(this).children("a").html().toLowerCase();
                if(enteredValue == optionValue){
                  brandMatched = true;
                  location.href = $(this).children("a").attr("href");
                }                
              });          
          }

          if(!brandMatched){
            $("#main-search-form").submit();
            //form submit code will be here
          }          
          
          clearInterval(intervalinit);         
        }          
      }, 500);
    }
  });
  
  if($(window).width() <= 768){
     $('.grey-bg-container').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
       autoplay: true
    });
    
    $('.slick-prev').hide();
    $('.slick-next').hide();
     }
	
});

/* confirm btn popup*/
$(".test-btn").click(function(){
  $(".confirm-popup").show();
  $("html").addClass("stop-scroll");
});
$(".test-no").click(function(){
  $(".confirm-popup").hide();
  $("html").removeClass("stop-scroll");
});
$('document').ready(function(){
  if($('body').hasClass('template-product')){
    if($(window).width() > 1025){
      var loopI = 0;
      var sidebarInt = setInterval(function(){
        loopI++;
        var sidebarHeight = $('.product-block-list__item--gallery .product-block-list__item.product-block-list__item--info').outerHeight();
        $('.product-block-list__wrapper .product-block-list__item--gallery').css({'min-height':sidebarHeight});
        if(loopI >= 20){
          clearInterval(sidebarInt);
        }
      }, 1000);
    }
    else {
      $('.product-block-list__wrapper .product-block-list__item--gallery').css({'min-height':'1px'});
    }
  }
});
$(window).resize(function(){
  if($('body').hasClass('template-product')){
    if($(window).width() > 1025){
      var sidebarHeight = $('.product-block-list__item--gallery .product-block-list__item.product-block-list__item--info').outerHeight();
      $('.product-block-list__wrapper .product-block-list__item--gallery').css({'min-height':sidebarHeight});
    }
    else {
      $('.product-block-list__wrapper .product-block-list__item--gallery').css({'min-height':'1px'});
    }
  }
});
function indexGridMouseEvents(e) {
  // console.log("indexGridMouseEvents");
  if(e?.target?.querySelector(".product-item__secondary-image")){
    let primary_grid_div = e.target.querySelector(".product-item__primary-image");
    let secondary_grid_div = e.target.querySelector(".product-item__secondary-image");
    if (primary_grid_div?.style && secondary_grid_div?.style) {
      if(e?.type == "mouseleave"){
        secondary_grid_div.style.visiblity = 'hidden';
        secondary_grid_div.style.opacity = 0;
        primary_grid_div.style.visiblity = 'visible';
        primary_grid_div.style.opacity = 1;
      }
      else if(e?.type == "mouseenter"){
        primary_grid_div.style.visiblity = 'hidden';
        primary_grid_div.style.opacity = 0;
        secondary_grid_div.style.visiblity = 'visible';
        secondary_grid_div.style.opacity = 1;
      }
    }
  }
}
if (document?.querySelectorAll(".index-product-grid")?.length) {
  document.querySelectorAll(".index-product-grid").forEach((singleDiv)=>{
    singleDiv.onmouseenter = indexGridMouseEvents;
    singleDiv.onmouseleave = indexGridMouseEvents;
  })
}